import { ReactNode } from "react";

import {
  QuestionnaireItem,
  QuestionnaireItemEnableWhen,
  QuestionnaireResponseItem,
  QuestionnaireResponseItemAnswer,
} from "@medplum/fhirtypes";
import { QuestionnaireItemType } from "@medplum/react";

import { TitleOrder } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";

export type IntakeFormFieldType = Record<
  QuestionnaireItemType,
  <T>(props: IntakeFormComponentProps<T>) => ReactNode
>;

export type IntakeFormInitialValuesType = Record<
  QuestionnaireItemType,
  string | null | object | boolean
>;

export type IntakeFormComponentProps<T> = {
  key: string;
  form: UseFormReturnType<T>;
  formFieldName: string;
  name: string;
  label: string;
  required?: boolean;
  placeholder?: string;
  rightSection?: string;
  icon?: string;
  mask?: string;
  enableWhen?: QuestionnaireItemEnableWhen[];
  questionnaireItem?: QuestionnaireItem;
  questionnaireResponseItem?: QuestionnaireResponseItem;
  group?: QuestionnaireItem;
  minRange?: number;
  maxRange?: number;
  minValue?: number;
  maxValue?: number;
  maxDecimalPlaces?: number;
  allowDecimal?: boolean;
  autoPopulate?: boolean;
  relatedField?: string;
  itemOrder?: number;
  groupTitleOrder?: TitleOrder;
  enableWhenBehavior?: EnableWhenBehavior;
  hasCodingInputDetails?: boolean;
  canSelectFutureDates?: boolean;
  valueSetIsCreatable?: boolean;
};

export enum EnableWhenBehavior {
  ALL = "all",
  ANY = "any",
}

export type FormItemAnswer = {
  display?: string;
  valueCoding?: {
    display?: string;
  };
};

export type IntakeFormItem =
  | Record<string, QuestionnaireResponseItemAnswer>
  | Record<string, unknown>;
export type IntakeFormItemAnswer = IntakeFormItem | string;
